import React, { forwardRef } from 'react';

import './_input.search.scss';
import './_input.search.dark-mode.scss';

import PropTypes from 'prop-types';
import { FormControl } from 'react-bootstrap';

import { UI_NAME } from '../../../utils/config';

const InputSearch = forwardRef((props, ref) => {
  const onClear = (e) => {
    e.preventDefault();

    if (props.onChange) {
      props.onChange({ target: { value: '' } });
    }

    if (ref && ref.current) {
      ref.current.focus();
    }
  };

  return (
    <div className={`${UI_NAME}-input-search`}>
      <FormControl
        inputRef={(inputRef) => { ref.current = inputRef }}
        {...props}
      />
      {props.value ? (
        <button className={`${UI_NAME}-input-search__icon`} onMouseDown={onClear}>
          <span className="far fa-times" />
        </button>
      ) : null}
    </div>
  );
});

InputSearch.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

InputSearch.defaultProps = {
  disabled: false,
}

export default InputSearch
